(() => {
  const initGallery = (gallery) => {
    if (gallery.dataset.daGalleryInitialized === 'true') return;

    const items = [...gallery.querySelectorAll('[data-da-gallery-item]')];
    const dialog = gallery.querySelector('[data-da-gallery-dialog]');
    const image = gallery.querySelector('[data-da-gallery-image]');
    const counter = gallery.querySelector('[data-da-gallery-counter]');
    const closeButton = gallery.querySelector('[data-da-gallery-close]');
    const previousButton = gallery.querySelector('[data-da-gallery-previous]');
    const nextButton = gallery.querySelector('[data-da-gallery-next]');
    if (!items.length || !dialog || !image) return;

    gallery.dataset.daGalleryInitialized = 'true';
    let activeIndex = 0;

    const render = () => {
      const item = items[activeIndex];
      image.src = item.dataset.daGallerySrc;
      image.alt = item.dataset.daGalleryAlt || '';
      if (counter) counter.textContent = `${activeIndex + 1} / ${items.length}`;
      const hideNavigation = items.length < 2;
      if (previousButton) previousButton.hidden = hideNavigation;
      if (nextButton) nextButton.hidden = hideNavigation;
    };

    const open = (index) => {
      activeIndex = index;
      render();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('da-installation-gallery-open');
    };

    const close = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('da-installation-gallery-open');
    };

    const step = (direction) => {
      activeIndex = (activeIndex + direction + items.length) % items.length;
      render();
    };

    items.forEach((item, index) => item.addEventListener('click', () => open(index)));
    closeButton?.addEventListener('click', close);
    previousButton?.addEventListener('click', () => step(-1));
    nextButton?.addEventListener('click', () => step(1));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('da-installation-gallery-open'));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-da-installation-gallery]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
